import { replace } from 'connected-react-router'
import { useAppDispatch } from 'hooks/reduxHooks'
import useQueryParams from 'hooks/useQueryParams'
import { useCallback, useMemo } from 'react'
import { encodeOfferIds } from '../ExperiencesSearch/utils'

const SELECTED_EXPERIENCES_IDS = 'selectedOfferIds'

export default function useSelectedItems() {
  const queryParameters = useQueryParams()
  const appDispatch = useAppDispatch()

  const selectedItemsIds = useMemo<Array<string> | undefined>(() => {
    const extractedIds = extractIdsFromUrl(queryParameters)
    if (extractedIds) {
      return extractIdsFromUrl(queryParameters).split(',')
    }
  }, [queryParameters])

  const setSelectedItems = useCallback((newItems: Array<App.ExperienceOffer>) => {
    const newUrlFilters = convertIdsToUrl(newItems, queryParameters)
    appDispatch(replace({
      search: newUrlFilters.toString(),
    }))
  }, [appDispatch, queryParameters])

  return {
    selectedItemsIds,
    setSelectedItems,
  }
}

function extractIdsFromUrl(urlExperiencesItemsIds: URLSearchParams): string | undefined {
  if (urlExperiencesItemsIds.has(SELECTED_EXPERIENCES_IDS)) {
    return urlExperiencesItemsIds.get(SELECTED_EXPERIENCES_IDS)
  }
  return
}

function convertIdsToUrl(experienceItems: Array<App.ExperienceOffer>, currentSearchParams: URLSearchParams) {
  const searchParams = new URLSearchParams(currentSearchParams)
  if (experienceItems.length > 0) {
    searchParams.set(SELECTED_EXPERIENCES_IDS, encodeOfferIds(experienceItems))
  } else {
    searchParams.delete(SELECTED_EXPERIENCES_IDS)
  }
  return searchParams
}
